<template>
  <div>
    <div class="panel panel-default">
      <div class="panel-heading">
        <div class="row">
          <div
            class="col-xs-12 col-sm-2 col-md-2 col-lg-2 text-center"
            style="margin-top: 6px"
          >
            <span class="fa fa-calendar icone_calendario" />
          </div>
          <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
            <p class="data_hora">{{
              formatarData(agendamento.data, 'DD/MM/YYYY')
            }}</p>
            <p class="data_hora">{{ agendamento.hora }}</p>
          </div>
          <div class="col-xs-11 col-sm-6 col-md-6 col-lg-6 text-right">
            <span
              :class="
                'pull-right status_agendamento agendamento-legenda-item--' +
                agendamento.status
              "
              >{{ agendamento.status }}</span
            >
          </div>
        </div>
      </div>
      <div class="panel-body panel_info">
        <table class="table table-striped tabela_info">
          <tbody>
            <tr :title="agendamento.paciente.nome">
              <td> <strong>Paciente</strong> </td>
              <td> {{ limitar(agendamento.paciente.nome, 20) }} </td>
            </tr>
            <tr>
              <td> <strong>Unidade</strong> </td>
              <td> {{ agendamento.unidade }} </td>
            </tr>
            <tr>
              <td> <strong>Especialidade</strong> </td>
              <td> {{ agendamento.especialidade }} </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="btn-group btn-group-justified" role="group" aria-label="...">
        <div class="btn-group" role="group">
          <button
            id="botaoLimpar"
            v-tooltip.bottom="'Excluir agendamento'"
            data-test-id="button-botaolimpar"
            name="botaoLimpar"
            type="button"
            class="btn btn-sm btn-default"
            @click="deletar(agendamento)"
          >
            <span class="fa fa-trash" />
            Excluir
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AgendamentoServico from '@/servicos/AgendamentoServico'
import * as formatadores from '@/utils/formatadores'
const agendamentoServico = new AgendamentoServico()

export default {
  name: 'ProfissionalAgendamentosFicha',
  props: {
    agendamento: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...formatadores,
    deletar(agendamento) {
      agendamentoServico.remover(agendamento._id).then((res) => {
        this.$emit('atualizar')
      })
    },
  },
}
</script>
<style scoped>
.data_hora {
  padding: 0;
  margin: 0;
  font-size: 1.1em;
}

.icone_calendario {
  font-size: 2.2em;
}

.status_agendamento {
  font-size: 1.1em;
  font-weight: bold;
  text-transform: uppercase;
}
</style>
